import { sendEmailVerification } from 'firebase/auth';
import {
  Container, Box, Dialog, DialogContent, Slide, IconButton, DialogTitle,
} from '@mui/material';
import ProfileTabs from '../../src/components/Profile';
import useAuth from '../../src/hook/auth';
import React from 'react';
import { useRouter } from 'next/router';
import Authentication from '../../src/components/Authentication';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { colors, radii } from '../../src/utils/designTokens';
// import ApprovedApps from '../../src/components/oauth/ApprovedApps';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Profile = ({ pathname, pageLoading }) => {
  const auth = useAuth();
  const [open, setOpen] = React.useState(false);
  const [openMembership, setOpenMembership] = React.useState(false);
  const router = useRouter();

  const emailVerification = async () => {
    if (auth?.user) {
      await sendEmailVerification(auth.user);
      setOpen(true);
    }
  };

  if (auth && !auth?.user && typeof window !== 'undefined' && !pageLoading) {
    router?.push({ pathname: '/auth', query: { from: router.asPath } });
  }

  return (
    <Box sx={{
      minHeight: '100vh',
      bgcolor: colors.neutral[25],
      pt: { md: 6, xs: 3 },
      pb: 4,
    }}>
      <Container maxWidth="md" sx={{ px: { xs: 2, md: 3 } }}>
        <ProfileTabs
          emailVerification={emailVerification}
          alertOpen={open}
          pathname={pathname}
          membershipOpen={setOpenMembership}
          pageLoading={pageLoading}
        />
        {/* <ApprovedApps user={auth?.user} /> */}
        {!pageLoading && (
          <Dialog
            open={openMembership}
            onClose={() => setOpenMembership(false)}
            TransitionComponent={Transition}
            keepMounted
            aria-describedby="auth-dialog"
            maxWidth="md"
            sx={{
              '& .MuiDialog-paper': {
                maxHeight: 'calc(100% - 64px)', width: '100% !important',
                transition: 'max-height 2s ease-in-out', boxShadow: 0, textAlign: 'center',
                borderRadius: `${radii.xl}px`,
              },
              '& .MuiDialogContent-root': { p: 0 },
              '& .MuiBackdrop-root': { backdropFilter: 'blur(6px)' },
            }}
          >
            <DialogTitle sx={{ m: 0, p: 0 }}>
              <IconButton
                aria-label="close"
                onClick={() => setOpenMembership(false)}
                sx={{ position: 'absolute', right: 8, top: 8, color: colors.neutral[400] }}
              >
                <CloseRoundedIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Authentication maxWidth={12} isPopup={true} />
            </DialogContent>
          </Dialog>
        )}
      </Container>
    </Box>
  );
};

export default Profile;
